<template>
    <div class="row mt-5">
        <h5 class="mb-2">
            <i class="fas fa-map-marked-alt text-primary"></i>
            ინტერაქტიული რუკა
            <div
                v-if="loading"
                class="spinner-grow spinner-grow-sm"
                role="status"
            >
                <span class="visually-hidden">Loading...</span>
            </div>
        </h5>
        <div class="col-md-3 my-2 card rounded-0">
            <div class="card-body filters-style py-3 px-2">
                <h6>
                    <i class="fas fa-th-large text-primary"></i>
                    კატეგორიები
                </h6>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="hotelsToggle"
                        v-model="hotelsToggle"
                    />
                    <label class="form-check-label" for="hotelsToggle">
                        განთავსება
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="restaurantsToggle"
                        v-model="restaurantsToggle"
                    />
                    <label class="form-check-label" for="restaurantsToggle">
                        კვება
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="entertainmentsToggle"
                        v-model="entertainmentsToggle"
                    />
                    <label class="form-check-label" for="entertainmentsToggle">
                        გართობა
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="agenciesToggle"
                        v-model="agenciesToggle"
                    />
                    <label class="form-check-label" for="agenciesToggle">
                        ტურისტული სააგენტოები
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="sightsToggle"
                        v-model="sightsToggle"
                    />
                    <label class="form-check-label" for="sightsToggle">
                        ღირსშესანიშნაობები
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="transportsToggle"
                        v-model="transportsToggle"
                    />
                    <label class="form-check-label" for="transportsToggle">
                        ტრანსპორტი
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="shopsToggle"
                        v-model="shopsToggle"
                    />
                    <label class="form-check-label" for="shopsToggle">
                        შოპინგი
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="schoolsToggle"
                        v-model="schoolsToggle"
                    />
                    <label class="form-check-label" for="schoolsToggle">
                        სასწავლო დაწესებულებები
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="medicinesToggle"
                        v-model="medicinesToggle"
                    />
                    <label class="form-check-label" for="medicinesToggle">
                        მედიცინა
                    </label>
                </div>
                <div class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="departmentsToggle"
                        v-model="departmentsToggle"
                    />
                    <label class="form-check-label" for="departmentsToggle">
                        უწყებები
                    </label>
                </div>
                <hr />
                <h6>
                    <i class="fas fa-map-marker-alt text-primary"></i>
                    ქალაქი/მუნიციპალ.
                </h6>
                <div
                    class="form-check"
                    v-for="municipality in municipalities"
                    :key="municipality.id"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="municipality.id"
                        :value="municipality.id"
                        v-model="selectedMunicipalities"
                    />
                    <label class="form-check-label" :for="municipality.id">
                        {{ municipality.name_ka }}
                    </label>
                </div>
            </div>
        </div>
        <div class="col-md-9 px-0 my-2">
            <GMapMap
                class="interactive-map w-100"
                :center="center"
                :zoom="zoom"
                :options="options"
                map-type-id="roadmap"
            >
                <GMapCluster
                    :zoomOnClick="zoomOnClick"
                    :minimumClusterSize="minimumClusterSize"
                    :styles="clusterIcon"
                >
                    <GMapMarker
                        v-for="hotel in filteredHotels"
                        :key="'holel-' + hotel.id"
                        v-show="hotelsToggle"
                        :position="{
                            lat: Number(hotel.lat),
                            lng: Number(hotel.long),
                        }"
                        :icon="'/assets/img/pins/pin-hotel.png'"
                        :clickable="true"
                        @click="openMarker('hotel-' + hotel.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === 'hotel-' + hotel.id"
                        >
                            <MapItem :item="hotel" :category="'hotels'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="restaurant in filteredRestaurants"
                        :key="'restaurant-' + restaurant.id"
                        :position="{
                            lat: Number(restaurant.lat),
                            lng: Number(restaurant.long),
                        }"
                        :icon="'/assets/img/pins/pin-restaurant.png'"
                        :clickable="true"
                        @click="openMarker('restaurant-' + restaurant.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="
                                openedMarkerID === 'restaurant-' + restaurant.id
                            "
                        >
                            <MapItem
                                :item="restaurant"
                                :category="'restaurants'"
                            />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="entertainment in filteredEntertainments"
                        :key="'entertainment-' + entertainment.id"
                        :position="{
                            lat: Number(entertainment.lat),
                            lng: Number(entertainment.long),
                        }"
                        :icon="'/assets/img/pins/pin-entertainment.png'"
                        :clickable="true"
                        @click="openMarker('entertainment-' + entertainment.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="
                                openedMarkerID ===
                                'entertainment-' + entertainment.id
                            "
                        >
                            <MapItem
                                :item="entertainment"
                                :category="'entertainments'"
                            />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="agency in filteredAgencies"
                        :key="'agency-' + agency.id"
                        :position="{
                            lat: Number(agency.lat),
                            lng: Number(agency.long),
                        }"
                        :icon="'/assets/img/pins/pin-agency.png'"
                        :clickable="true"
                        @click="openMarker('agency-' + agency.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === 'agency-' + agency.id"
                        >
                            <MapItem :item="agency" :category="'agencies'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="sight in filteredSights"
                        :key="'sight-' + sight.id"
                        :position="{
                            lat: Number(sight.lat),
                            lng: Number(sight.long),
                        }"
                        :icon="'/assets/img/pins/pin-sight.png'"
                        :clickable="true"
                        @click="openMarker('sight-' + sight.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === 'sight-' + sight.id"
                        >
                            <MapItem :item="sight" :category="'sights'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="transport in filteredTransports"
                        :key="'transport-' + transport.id"
                        :position="{
                            lat: Number(transport.lat),
                            lng: Number(transport.long),
                        }"
                        :icon="'/assets/img/pins/pin-transport.png'"
                        :clickable="true"
                        @click="openMarker('transport-' + transport.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="
                                openedMarkerID === 'transport-' + transport.id
                            "
                        >
                            <MapItem
                                :item="transport"
                                :category="'transports'"
                            />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="shop in filteredShops"
                        :key="'shop-' + shop.id"
                        v-show="shopsToggle"
                        :position="{
                            lat: Number(shop.lat),
                            lng: Number(shop.long),
                        }"
                        :icon="'/assets/img/pins/pin-shop.png'"
                        :clickable="true"
                        @click="openMarker('shop-' + shop.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === 'shop-' + shop.id"
                        >
                            <MapItem :item="shop" :category="'shops'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="school in filteredSchools"
                        :key="'school-' + school.id"
                        v-show="schoolsToggle"
                        :position="{
                            lat: Number(school.lat),
                            lng: Number(school.long),
                        }"
                        :icon="'/assets/img/pins/pin-school.png'"
                        :clickable="true"
                        @click="openMarker('school-' + school.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="openedMarkerID === 'school-' + school.id"
                        >
                            <MapItem :item="school" :category="'schools'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="medicine in filteredMedicines"
                        :key="'medicine-' + medicine.id"
                        v-show="medicinesToggle"
                        :position="{
                            lat: Number(medicine.lat),
                            lng: Number(medicine.long),
                        }"
                        :icon="'/assets/img/pins/pin-medicine.png'"
                        :clickable="true"
                        @click="openMarker('medicine-' + medicine.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="
                                openedMarkerID === 'medicine-' + medicine.id
                            "
                        >
                            <MapItem :item="medicine" :category="'medicines'" />
                        </GMapInfoWindow>
                    </GMapMarker>
                    <GMapMarker
                        v-for="department in filteredDepartments"
                        :key="'department-' + department.id"
                        v-show="departmentsToggle"
                        :position="{
                            lat: Number(department.lat),
                            lng: Number(department.long),
                        }"
                        :icon="'/assets/img/pins/pin-department.png'"
                        :clickable="true"
                        @click="openMarker('department-' + department.id)"
                        @closeclick="openMarker(null)"
                    >
                        <GMapInfoWindow
                            :closeclick="closeClick"
                            @closeclick="openMarker(null)"
                            :opened="
                                openedMarkerID === 'department-' + department.id
                            "
                        >
                            <MapItem
                                :item="department"
                                :category="'departments'"
                            />
                        </GMapInfoWindow>
                    </GMapMarker>
                </GMapCluster>
            </GMapMap>
        </div>
    </div>
</template>

<script>
import { getPinsByCategory, getMunicipalities } from "../Services/ApiService";
import MapItem from "./map/MapItem.vue";

export default {
    components: { MapItem },
    data() {
        return {
            municipalities: [],
            selectedMunicipalities: [],
            hotels: [],
            hotelsToggle: false,
            restaurants: [],
            restaurantsToggle: false,
            entertainments: [],
            entertainmentsToggle: false,
            agencies: [],
            agenciesToggle: false,
            sights: [],
            sightsToggle: false,
            transports: [],
            transportsToggle: false,
            shops: [],
            shopsToggle: false,
            schools: [],
            schoolsToggle: false,
            medicines: [],
            medicinesToggle: false,
            departments: [],
            departmentsToggle: false,
            zoom: 9,
            zoomOnClick: true,
            minimumClusterSize: 10,
            loading: false,
            options: {
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                gestureHandling: "greedy",
                styles: [
                    {
                        featureType: "poi.attraction",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.business",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.government",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.medical",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.place_of_worship",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.school",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "poi.sports_complex",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                ],
            },
            center: { lat: 41.6835552, lng: 42.0821636 },
            openedMarkerID: null,
            clusterIcon: [
                {
                    textColor: "#000",
                    textSize: 18,
                    url: "/assets/img/clusters/map-cluster2.svg",
                    height: 40,
                    width: 40,
                },
            ],
            closeClick: true,
        };
    },
    watch: {
        hotelsToggle: {
            handler() {
                this.getRecords("hotels");
            },
            deep: true,
        },
        restaurantsToggle: {
            handler() {
                this.getRecords("restaurants");
            },
            deep: true,
        },
        entertainmentsToggle: {
            handler() {
                this.getRecords("entertainments");
            },
            deep: true,
        },
        agenciesToggle: {
            handler() {
                this.getRecords("agencies");
            },
            deep: true,
        },
        sightsToggle: {
            handler() {
                this.getRecords("sights");
            },
            deep: true,
        },
        transportsToggle: {
            handler() {
                this.getRecords("transports");
            },
            deep: true,
        },
        departmentsToggle: {
            handler() {
                this.getRecords("departments");
            },
            deep: true,
        },
        schoolsToggle: {
            handler() {
                this.getRecords("schools");
            },
            deep: true,
        },
        medicinesToggle: {
            handler() {
                this.getRecords("medicines");
            },
            deep: true,
        },
    },
    computed: {
        filteredHotels() {
            let hotels = this.hotels;

            if (this.selectedMunicipalities.length > 0 && this.hotelsToggle) {
                return (hotels = hotels.filter((hotel) => {
                    return this.selectedMunicipalities.includes(
                        hotel.municipality.id
                    );
                }));
            }

            if (this.hotelsToggle) {
                return hotels;
            }
        },
        filteredRestaurants() {
            let restaurants = this.restaurants;

            if (
                this.selectedMunicipalities.length > 0 &&
                this.restaurantsToggle
            ) {
                return (restaurants = restaurants.filter((restaurant) => {
                    return this.selectedMunicipalities.includes(
                        restaurant.municipality.id
                    );
                }));
            }

            if (this.restaurantsToggle) {
                return restaurants;
            }
        },
        filteredEntertainments() {
            let entertainments = this.entertainments;

            if (
                this.selectedMunicipalities.length > 0 &&
                this.entertainmentsToggle
            ) {
                return (entertainments = entertainments.filter(
                    (entertainment) => {
                        return this.selectedMunicipalities.includes(
                            entertainment.municipality.id
                        );
                    }
                ));
            }

            if (this.entertainmentsToggle) {
                return entertainments;
            }
        },
        filteredAgencies() {
            let agencies = this.agencies;

            if (this.selectedMunicipalities.length > 0 && this.agenciesToggle) {
                return (agencies = agencies.filter((agency) => {
                    return this.selectedMunicipalities.includes(
                        agency.municipality.id
                    );
                }));
            }

            if (this.agenciesToggle) {
                return agencies;
            }
        },
        filteredSights() {
            let sights = this.sights;

            if (this.selectedMunicipalities.length > 0 && this.sightsToggle) {
                return (sights = sights.filter((sight) => {
                    return this.selectedMunicipalities.includes(
                        sight.municipality.id
                    );
                }));
            }

            if (this.sightsToggle) {
                return sights;
            }
        },
        filteredTransports() {
            let transports = this.transports;

            if (
                this.selectedMunicipalities.length > 0 &&
                this.transportsToggle
            ) {
                return (transports = transports.filter((transport) => {
                    return this.selectedMunicipalities.includes(
                        transport.municipality.id
                    );
                }));
            }

            if (this.transportsToggle) {
                return transports;
            }
        },
        filteredShops() {
            let shops = this.shops;

            if (this.selectedMunicipalities.length > 0 && this.shopsToggle) {
                return (shops = shops.filter((shop) => {
                    return this.selectedMunicipalities.includes(
                        shop.municipality.id
                    );
                }));
            }

            if (this.shopsToggle) {
                return shops;
            }
        },
        filteredSchools() {
            let schools = this.schools;

            if (this.selectedMunicipalities.length > 0 && this.schoolsToggle) {
                return (schools = schools.filter((school) => {
                    return this.selectedMunicipalities.includes(
                        school.municipality.id
                    );
                }));
            }

            if (this.schoolsToggle) {
                return schools;
            }
        },
        filteredMedicines() {
            let medicines = this.medicines;

            if (
                this.selectedMunicipalities.length > 0 &&
                this.medicinesToggle
            ) {
                return (medicines = medicines.filter((medicine) => {
                    return this.selectedMunicipalities.includes(
                        medicine.municipality.id
                    );
                }));
            }

            if (this.medicinesToggle) {
                return medicines;
            }
        },
        filteredDepartments() {
            let departments = this.departments;

            if (
                this.selectedMunicipalities.length > 0 &&
                this.departmentsToggle
            ) {
                return (departments = departments.filter((department) => {
                    return this.selectedMunicipalities.includes(
                        department.municipality.id
                    );
                }));
            }

            if (this.departmentsToggle) {
                return departments;
            }
        },
    },
    methods: {
        getRecords(cat) {
            this.loading = true;
            getPinsByCategory(cat)
                .then((res) => {
                    if (cat === "hotels") this.hotels = res.data.hotels;
                    if (cat === "restaurants")
                        this.restaurants = res.data.restaurants;
                    if (cat === "entertainments")
                        this.entertainments = res.data.entertainments;
                    if (cat === "agencies") this.agencies = res.data.agencies;
                    if (cat === "sights") this.sights = res.data.sights;
                    if (cat === "transports")
                        this.transports = res.data.transports;
                    if (cat === "shops") this.shops = res.data.shops;
                    if (cat === "schools") this.schools = res.data.schools;
                    if (cat === "medicines")
                        this.medicines = res.data.medicines;
                    if (cat === "departments")
                        this.departments = res.data.departments;
                    this.loading = false;
                })
                .catch(console.error());
        },
        openMarker(str) {
            this.openedMarkerID = str;
        },
    },
    mounted() {
        getMunicipalities()
            .then((res) => {
                this.municipalities = res.data.municipalities;
            })
            .catch(console.error());
    },
};
</script>

<style scoped>
.interactive-map {
    height: 450px;
}

.filters-style {
    height: 450px;
    display: block;
    overflow-y: auto;
    overflow-x: hidden;
}

@media screen and (max-width: 767px) {
    .interactive-map {
        height: 380px;
    }

    .filters-style {
        height: 200px;
    }
}
</style>
